import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Editor } from './editor.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentesService } from '../componentes.service';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

@NgModule({
	declarations: [
		Editor
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		CKEditorModule
	],
	providers: [
		ComponentesService,
	],
	exports: [
		Editor,
		FormsModule,
		ReactiveFormsModule
	]
})
export class EditorModule { }
